// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ZodiacPisces,
    ZodiacSagittarius,
    ZodiacScorpio,
    ZodiacTaurus,
    ZodiacVirgo,
    ZoomIn,
    ZoomOut,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 7 lucide icons from "zodiac-pisces" through "zoom-out", inclusive. */
const shard: Record<string, LucideIcon> = {
    "zodiac-pisces": ZodiacPisces,
    "zodiac-sagittarius": ZodiacSagittarius,
    "zodiac-scorpio": ZodiacScorpio,
    "zodiac-taurus": ZodiacTaurus,
    "zodiac-virgo": ZodiacVirgo,
    "zoom-in": ZoomIn,
    "zoom-out": ZoomOut,
};

export default shard;
